import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

/**
 * Listens for `zooi:lazy-chunk-failed` events dispatched by `lazyWithRetry`
 * and renders a non-blocking banner explaining that the page is refreshing.
 *
 * Mounted once globally in App.tsx — invisible until a failure happens.
 */
const LazyChunkBanner = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState<string>("");

  useEffect(() => {
    type Detail = { chunkName?: string; message?: string; willReload?: boolean };
    const handler = (ev: Event) => {
      const detail = (ev as CustomEvent<Detail>).detail ?? {};
      const willReload = detail.willReload !== false;
      setMessage(
        willReload
          ? "Vi laddar in en uppdaterad version av sidan…"
          : "Sidan kunde inte laddas. Försök igen om en stund.",
      );
      setVisible(true);
    };
    window.addEventListener("zooi:lazy-chunk-failed", handler);
    return () => window.removeEventListener("zooi:lazy-chunk-failed", handler);
  }, []);

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-2 bg-primary px-4 py-2 text-sm text-primary-foreground shadow-md animate-in slide-in-from-top duration-200"
    >
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
};

export default LazyChunkBanner;
